export enum AutoActiveActionType {
  All = 'all',
  EditAutoActivationMode = 'editAutoActivationMode'
}
